import { useReducedMotion } from 'framer-motion';

/**
 * Chart animation props.
 *
 * Recharts animates via requestAnimationFrame, which never settles when the
 * viewer has asked for reduced motion (and in headless/print contexts). Passing
 * these props to every animated Recharts element means the shape is drawn at
 * its final value instead of being stuck at its zero-state.
 */
export default function useChartMotion(duration = 900) {
  const reduce = useReducedMotion();
  return {
    isAnimationActive: !reduce,
    animationDuration: reduce ? 0 : duration,
  };
}
